/**
 * @generated SignedSource<<a5700a98f696d94961025fe459b46ebc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productListSyncWithEcommerceMutation$variables = {
  productIDs: ReadonlyArray<string>;
};
export type productListSyncWithEcommerceMutation$data = {
  readonly syncWithEcommerce: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly smallImageUrl: string;
  }> | null;
};
export type productListSyncWithEcommerceMutation = {
  response: productListSyncWithEcommerceMutation$data;
  variables: productListSyncWithEcommerceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIDs"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIDs",
        "variableName": "productIDs"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "syncWithEcommerce",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "smallImageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productListSyncWithEcommerceMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productListSyncWithEcommerceMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b03d99cbb1bbee0a9fb19a18a54fc45d",
    "id": null,
    "metadata": {},
    "name": "productListSyncWithEcommerceMutation",
    "operationKind": "mutation",
    "text": "mutation productListSyncWithEcommerceMutation(\n  $productIDs: [String!]!\n) {\n  syncWithEcommerce(productIDs: $productIDs) {\n    id\n    name\n    smallImageUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc2cfcb8a8358652da6a87a97c207460";

export default node;
